import Sanitize, { SimpleSanitize,sanitizeGA4} from "core/Utils/SanitizeString";
import {isNullOrBlank} from "core/Utils/Utils";
export default class Analytics {
    constructor() {
        this.DEFAULT_PROPS = {
            event: "event",
            eventCategory: "minha-claro:meu-perfil",
        };
       
    
      }
     init() {
      window.dataLayer = window.dataLayer || [];
    }
    
     setEvent(props = {}) {
      const mergedProps = { ...this.DEFAULT_PROPS, ...props };
      const { eventLabel, eventAction } = mergedProps; 
      const sanitizedEventLabel = Sanitize(eventLabel);
      const sanitizedEventAction= Sanitize(eventAction);
      
      if(!eventAction){
        throw new Error('Parâmetro eventAction é obrigatório!');
      }
      if(!eventLabel){
        throw new Error('Parâmetro EventLabel é obrigatório!');
      }
      const result = {
        ...mergedProps,
        eventAction: sanitizedEventAction,
        eventLabel: sanitizedEventLabel
      }
  
      window.dataLayer.push(result);
    }


    setEventGA4(props = {},eventType="") {
   
      const { custom_section, custom_title } = props; 
      const sanitizedCustomSection = sanitizeGA4(custom_section);
      const sanitizedCustomTitle= sanitizeGA4(custom_title);
     
      
      const result = {
        event: eventType,
        custom_section: sanitizedCustomSection,
        custom_title: sanitizedCustomTitle
      }
      if(!isNullOrBlank(props?.custom_callback)){

        result.custom_callback= sanitizeGA4(props.custom_callback)

      }
      window.dataLayer.push(result);
    }

     setVirtualPageView(url= ""){
      window.dataLayer = window.dataLayer || [];
      let page = url || window.location.pathname
      const sanitizedPage = SimpleSanitize(page);
    
      const event = {
        event: "virtual-pageview",
        page: sanitizedPage ,
      };
      // console.table(event)
  
      window.dataLayer.push(event);
    };

    setVirtualPageViewGA4(title= ""){
      window.dataLayer = window.dataLayer || [];
   
      const sanitizedTitle = SimpleSanitize(title);
    
      const event = {
        event: "virtual-pageview",
        page: sanitizedTitle ,
      };
      // console.table(event)


    
      // window.dataLayer.push(event);
    };
    setClaroID(id= ""){
      window.dataLayer = window.dataLayer || [];

    
      const event = {
        claro_id: id,
      };
      // console.table(event)
      window.dataLayer.push(event);
    };
    
  
}